<template>
  <div class="cert">
    <div class="cert__no">{{ no }}</div>
    <div class="cert__content">
      <div class="cert__winner">{{ winner }}</div>
      <div class="cert__main">
        恭喜你在2020年{{ cpName }}
        <span class="cert__step">{{ cpStep }}</span>
        中表现优异，获得
        <span class="cert__city">{{ city }}</span>
      </div>
      <div class="cert__prize">{{ prize }}</div>
    </div>
    <img class="cert__bg" :src="bgImage" />
  </div>
</template>

<script>
export default {
  props: {
    no: String,
    city: String,
    winner: String,
    cpName: String,
    cpStep: String,
    prize: String,
    bgImage: String,
  },
}
</script>

<style lang="less" scoped>
.cert {
  position: relative;
  width: 3520px;
  height: 2351px;
  line-height: 1;

  &__no {
    position: absolute;
    top: 232px;
    left: 516px;
    font-size: 52px;
    font-family: DIN Alternate;
    font-weight: bold;
    color: rgba(51,51,51,1);
  }

  &__content {
    padding: 924px 40px;
    text-align: center;
  }

  &__winner {
    font-size: 88px;
    font-weight: 500;
    color: rgba(51,51,51,1);
  }

  &__main {
    margin-top: 56px;
    font-size: 67px;
    font-weight: 400;
    color: rgba(51,51,51,1);
  }

  &__prize {
    margin-top: 74px;
    font-size: 148px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(51,51,51,1);
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
}
</style>
